import { apiServerUrl, ExternalApi } from "@/apis/apiService";
import { useOrganisationStore } from "@/plugins/store";
import { keysToCamelCase } from "@/helpers/stringProcessors";
import { Organisation } from "@/helpers/interfaces/organisations";
import { getRequestConfig } from "@esenda/core-ui/utils";
import { getCommonHeaderParams } from "@/helpers/api";
import { HTTP_METHOD } from "@esenda/core-ui/constants";

export const getOrganisationData = async (
    shortcode: string,
    formName: string,
) => {
    /**
     * Internal API call to retrieve the organisation data. If successful,
     * it will save the data to the session storage, otherwise it will redirect
     * to 404 or display an error.
     * @param  {[string]} shortcode - organisation shortcode
     * @param  {[string]} formName - invoice/others
     * @return {[{void}]}
     */
    const organisationStore = useOrganisationStore();

    /** Define the behaviour if an error occurs during the API call */
    const errorHandlerConfig = {
        userAction: "refresh", // user needs to refresh the page
        sentryTransactionName: "getOrganisationDataAPI",
        redirectTo: "404", // redirect to the 404 page
    };

    const externalApi = new ExternalApi();
    const { data } = await externalApi.callExternalApi(
        getRequestConfig(
            `${apiServerUrl}/organisations/${shortcode}?form-name=${formName}`,
            HTTP_METHOD.GET,
            getCommonHeaderParams(),
        ),
        errorHandlerConfig,
    );

    if (data !== null) {
        const organisation: Organisation = keysToCamelCase(data);
        organisationStore.setShortcode(shortcode);
        organisationStore.setOrganisation(organisation);
    }
};
